import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { inject } from '@angular/core';
import { ToastService } from '@services/toast/toast.service';
import { BrandService } from '@services/brand/brand.service'; 
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const errorInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const toastService = inject(ToastService);
  const brandService = inject(BrandService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // message extraction
      const rawMessage =
        (typeof error.error === 'string' && error.error) ||
        error.error?.message ||
        error.message ||
        error.name ||
        'Unknown error';

      // replace ONLY when token exists in message
      const finalMessage = brandService.replaceManufacturerPlaceholders(rawMessage);


      // Suppress toast for certain API errors
      const suppressedToastApis = ['v1/order/get/eta'];
      const shouldSuppressToast = suppressedToastApis.some(api => req.url.includes(api));
      if (!shouldSuppressToast) {
        toastService.show(finalMessage, 'error');
      }

      switch (error.status) {
        case 401:
          console.warn('Unauthorized - Token may be expired or missing.');
          break;

        case 403:
          console.warn("Forbidden - You dont have permission to access this resource.");
          break;

        case 500:
          console.error('Server Error - Something went wrong on the server.');
          break;

        default:
          console.error(`Unhandled Error (${error.status}):`, error.message);
          break;
      }

      return throwError(() => error);
    })
  );
};